import { Paths } from '@/pages/routers';

export const menusOBD = [
  {
    label: 'Directory',
    url: Paths.Directory,
    oldUrl: Paths.Entity,
    params: ['query', 'region', 'country'],
    clickable: true,
  },
  {
    label: 'Compare',
    url: Paths.Compare,
    oldUrl: Paths.Compare,
    params: ['countryCode'],
    clickable: true,
  },
  {
    label: 'FinTech Map',
    url: Paths.FintechMap,
    oldUrl: Paths.FintechMap,
    params: [''],
    clickable: true,
  },
  {
    label: 'News',
    url: Paths.News,
    oldUrl: Paths.Article,
    params: [''],
    clickable: true,
  },
  {
    label: 'Standards',
    url: Paths.Standards,
    oldUrl: Paths.Standards,
    params: [''],
    clickable: true,
  },
];

export const menusDakko = [
  {
    label: 'Directory',
    url: Paths.Directory,
    oldUrl: '',
    params: ['query', 'region', 'country'],
    clickable: true,
  },
  {
    label: 'News and Events',
    url: Paths.News,
    oldUrl: '',
    params: [''],
    clickable: true,
  },
  {
    label: 'Get The App',
    url: Paths.GetTheApp,
    oldUrl: '',
    params: [],
    clickable: false,
  },
];
